import React, { useEffect, useState } from "react";
import axios from "axios";
import "./admindashboard.css";
import AdminNavBar from "../AdminNav/AdminNav";
import { Link } from "react-router-dom";

const colors = [
  "#17676a",
  "#61aaa0",
  "#b3cec0",
  "#dcb97c",
  "#8595b4",
  "#d7e1df",
];
const brands = [
  ["98 Acres", "98-acres.jpeg"],
  ["Ravana Pool Club", "ravana.jpeg"],
  ["Flying Ravana", "flying-ravana.jpeg"],
  ["Le Maas Tota", "villa.jpeg"],
  ["Tea Factory", "tea-factory.jpeg"],
  ["Walaa kulu", "walaa.jpeg"],
  ["Halpe Tea", "halpe.jpeg"],
  ["Ella Swing", "ella-swing.jpeg"],
  ["Amber Swing", "amber-swing.jpeg"],
  ["Ceylon Tea", "ceylon-tea.jpeg"],
  ["Halpe Tea Tour", "halpe-tour.jpeg"],
];
const endpoints = [
  "/api/AssetRegisterDetails/getAssetDetails",
  "/api/users/getallUsers",
  "/api/PendingAssetRegisterDetails/getPendingAssetDetails",
  "/api/transfer/getPendingTransferAssetDetails",
];
const groupBy = (items, key) =>
  Object.entries(
    items.reduce((groups, item) => {
      const label = item[key] || "Unassigned";
      groups[label] = (groups[label] || 0) + 1;
      return groups;
    }, {}),
  ).sort((a, b) => b[1] - a[1]);
export default function DashBoard() {
  const [data, setData] = useState([null, null, null, null]);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  const [company, setCompany] = useState("All companies");
  useEffect(() => {
    let active = true;
    setLoading(true);
    Promise.allSettled(
      endpoints.map((url) =>
        axios.get(url).then((response) => {
          if (!Array.isArray(response.data)) throw new Error("Invalid data");
          return response.data;
        }),
      ),
    ).then((results) => {
      if (active) {
        setData(
          results.map((result) =>
            result.status === "fulfilled" ? result.value : null,
          ),
        );
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, [retry]);
  const [assets, users, pending, transfers] = data;
  const filtered = (assets || []).filter(
    (asset) => company === "All companies" || asset.company === company,
  );
  const categories = groupBy(filtered, "category");
  const chartGroups =
    categories.length > 6
      ? [
          ...categories.slice(0, 5),
          [
            "Other categories",
            categories.slice(5).reduce((sum, row) => sum + row[1], 0),
          ],
        ]
      : categories;
  let offset = 0;
  const gradient = chartGroups
    .map(([label, count], i) => {
      const start = offset;
      offset += (count / filtered.length) * 100;
      return colors[i] + " " + start + "% " + offset + "%";
    })
    .join(", ");
  const companies = groupBy(assets || [], "company");
  const display = (value) =>
    loading ? "…" : value == null ? "—" : value.toLocaleString();
  const cards = [
    [
      "Registered assets",
      assets?.length,
      "layer-group",
      "/AssetDetails",
      "Across the group",
      "teal",
    ],
    [
      "People & access",
      users?.length,
      "users",
      "/Users",
      "All registered users",
      "sage",
    ],
    [
      "Pending registration",
      pending?.length,
      "clock",
      "/pendingRegisterasset",
      "Awaiting approval",
      "amber",
    ],
    [
      "Pending transfers",
      transfers?.length,
      "arrow-right-arrow-left",
      "/TransferAssetReport",
      "Awaiting completion",
      "blue",
    ],
  ];
  return (
    <div className="vl-dashboard-page">
      <AdminNavBar />
      <main className="vl-dashboard">
        <div className="vl-breadcrumb">
          Workspace <span>/</span> <strong>Overview</strong>
        </div>
        <div className="vl-page-heading">
          <div>
            <div className="vl-eyebrow">YOUR GROUP, AT A GLANCE</div>
            <h1>
              Asset overview<span>.</span>
            </h1>
            <p>A clear view of your assets, people and operations.</p>
          </div>
          <Link className="vl-primary" to="/AssetRegister">
            <i className="fas fa-plus" /> Register asset
          </Link>
        </div>
        {/*<section className="vl-welcome">
          <div>
            <span className="vl-pill">
              <span /> VELLA GROUP OF COMPANIES
            </span>
            <h2>Every asset. One connected view.</h2>
            <p>Manage your portfolio with confidence, across every company.</p>
            <Link to="/GetReport">
              Explore asset reports <i className="fas fa-arrow-right" />
            </Link>
          </div>
          <div className="vl-welcome-art" aria-hidden="true">
            <div />
            <div />
            <div />
            <i className="fas fa-layer-group" />
          </div>
        </section>*/}
        {!loading && data.some((item) => item === null) && (
          <div className="vl-error" role="alert">
            Some dashboard data could not be loaded. Unavailable values are
            shown as —.
            <button onClick={() => setRetry(retry + 1)}>Try again</button>
          </div>
        )}
        <section
          className="vl-stats"
          aria-label="Group summary"
          aria-busy={loading}
        >
          {cards.map(([label, count, icon, to, note, tone]) => (
            <Link className={"vl-stat " + tone} to={to} key={label}>
              <div className="vl-stat-top">
                <span>{label}</span>
                <i className={"fas fa-" + icon} />
              </div>
              <strong>{display(count)}</strong>
              <div className="vl-stat-bottom">
                <span>{note}</span>
                <i className="fas fa-arrow-up-right-from-square" />
              </div>
            </Link>
          ))}
        </section>
        <div className="vl-chart-grid">
          <section className="vl-panel">
            <div className="vl-panel-heading">
              <div>
                <h2>Asset composition</h2>
                <p>Your inventory, by category</p>
              </div>
              <label className="vl-select">
                <span className="visually-hidden">Filter chart by company</span>
                <select
                  value={company}
                  onChange={(e) => setCompany(e.target.value)}
                >
                  <option>All companies</option>
                  {companies.map(([name]) => (
                    <option key={name}>{name}</option>
                  ))}
                </select>
              </label>
            </div>
            {loading || !assets || !filtered.length ? (
              <div className="vl-empty">
                {loading
                  ? "Loading asset composition…"
                  : !assets
                    ? "Asset data is unavailable."
                    : "No registered assets to display."}
              </div>
            ) : (
              <div className="vl-composition">
                <div
                  className="vl-donut"
                  role="img"
                  aria-label={chartGroups
                    .map(([name, count]) => name + ": " + count)
                    .join(", ")}
                  style={{ background: "conic-gradient(" + gradient + ")" }}
                >
                  <div>
                    <strong>{filtered.length.toLocaleString()}</strong>
                    <span>Total assets</span>
                  </div>
                </div>
                <ul className="vl-legend">
                  {chartGroups.map(([name, count], i) => (
                    <li key={name}>
                      <span
                        className="vl-dot"
                        style={{ background: colors[i] }}
                      />
                      <span>{name}</span>
                      <strong>{count.toLocaleString()}</strong>
                      <small>
                        {Math.round((count / filtered.length) * 100)}%
                      </small>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <div className="vl-panel-foot">
              <span>Based on registered assets</span>
              <Link to="/category">
                View categories <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </section>
          <section className="vl-panel">
            <div className="vl-panel-heading">
              <div>
                <h2>Assets across companies</h2>
                <p>Where your assets belong</p>
              </div>
              <span className="vl-count">
                {display(assets ? companies.length : null)} companies
              </span>
            </div>
            {loading || !assets || !companies.length ? (
              <div className="vl-empty">
                {loading
                  ? "Loading company distribution…"
                  : !assets
                    ? "Company distribution is unavailable."
                    : "Company distribution will appear as assets are added."}
              </div>
            ) : (
              <div className="vl-bars">
                {companies.slice(0, 5).map(([name, count], i) => (
                  <div className="vl-bar-row" key={name}>
                    <div>
                      <span>{name}</span>
                      <strong>{count.toLocaleString()}</strong>
                    </div>
                    <div className="vl-bar-track">
                      <span
                        style={{
                          width: (count / companies[0][1]) * 100 + "%",
                          background: colors[i],
                        }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="vl-panel-foot">
              <span>Top 5 companies by asset count</span>
              <Link to="/AssetDetails">
                View inventory <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </section>
        </div>
        <section className="vl-panel vl-workflow">
          <div className="vl-panel-heading">
            <div>
              <h2>Keep things moving</h2>
              <p>Your asset workflow, from registration to transfer</p>
            </div>
            <span className="vl-subtle">OPERATIONS</span>
          </div>
          <div className="vl-flow">
            {[
              [
                "01",
                "Register",
                "Add an asset to the group",
                "circle-plus",
                "/AssetRegister",
              ],
              [
                "02",
                "Review",
                display(pending?.length) + " registrations pending",
                "clipboard-check",
                "/pendingRegisterasset",
              ],
              [
                "03",
                "Manage",
                display(assets?.length) + " assets in your inventory",
                "layer-group",
                "/AssetDetails",
              ],
             /* [
                "04",
                "Transfer",
                display(transfers?.length) + " transfers pending",
                "arrow-right-arrow-left",
                "/TransferAssetReport",
              ],*/
            ].map(([n, title, description, icon, to]) => (
              <Link to={to} key={n}>
                <span className="vl-flow-icon">
                  <i className={"fas fa-" + icon} />
                </span>
                <div>
                  <small>STEP {n}</small>
                  <strong>{title}</strong>
                  <p>{description}</p>
                </div>
                <i className="fas fa-chevron-right" />
              </Link>
            ))}
          </div>
        </section>
        <div className="vl-bottom-grid">
          <section className="vl-panel">
            <div className="vl-panel-heading">
              <div>
                <h2>One group. Many experiences.</h2>
                <p>Our family of Vella brands</p>
              </div>
            </div>
            <div className="vl-brand-grid">
              {brands.map(([name, file]) => (
                <div key={name} title={name}>
                  <img src={"/brands/" + file} alt={name} loading="lazy" />
                  <span>{name}</span>
                </div>
              ))}
            </div>
          </section>
          <section className="vl-panel">
            <div className="vl-panel-heading">
              <div>
                <h2>Your team</h2>
                <p>Access across the organisation</p>
              </div>
              <Link to="/Users" aria-label="View users">
                <i className="fas fa-arrow-up-right-from-square" />
              </Link>
            </div>
            <div className="vl-team">
              {[
                ["Admin", "Administrators"],
                ["CompanyAdmin", "Company users"],
                ["DepartmentAdmin", "Department users"],
                ["OtherUser", "Other users"],
              ].map(([role, label]) => (
                <div key={role}>
                  <span>{label}</span>
                  <strong>
                    {display(
                      users
                        ? users.filter((user) => user.selectedOption === role)
                            .length
                        : null,
                    )}
                  </strong>
                </div>
              ))}
            </div>
          </section>
        </div>
        <footer className="vl-footer">
          <span>
            VELLA <span> / </span> Asset Management
          </span>
          <span>Connected companies. Confident decisions.</span>
        </footer>
      </main>
    </div>
  );
}
